import { img } from "@/lib/api";

export const PORTRAIT = [638, 1011];
const NAVY = "#0E1729";
const LIGHT = "#F4F6F8";

export function loadImg(url) {
  return new Promise((resolve) => {
    if (!url) return resolve(null);
    const i = new Image();
    i.crossOrigin = "anonymous";
    i.onload = () => resolve(i);
    i.onerror = () => resolve(null);
    i.src = img(url);
  });
}

function mark(ctx, x, y, s, tile, fg) {
  const k = s / 64;
  ctx.fillStyle = tile;
  ctx.beginPath();
  ctx.roundRect(x, y, s, s, 15 * k);
  ctx.fill();
  ctx.fillStyle = fg;
  ctx.beginPath();
  [[32, 13], [51, 30], [51, 51], [13, 51], [13, 30]].forEach(([a, b], i) => (i ? ctx.lineTo(x + a * k, y + b * k) : ctx.moveTo(x + a * k, y + b * k)));
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = tile;
  ctx.beginPath();
  ctx.arc(x + 32 * k, y + 34.5 * k, 5.2 * k, 0, Math.PI * 2);
  ctx.fill();
  ctx.beginPath();
  ctx.moveTo(x + 29.6 * k, y + 36.5 * k);
  ctx.lineTo(x + 28 * k, y + 45.5 * k);
  ctx.lineTo(x + 36 * k, y + 45.5 * k);
  ctx.lineTo(x + 34.4 * k, y + 36.5 * k);
  ctx.fill();
}

function wrapCenter(ctx, text, cx, y, max, size, weight, lh, maxLines = 2) {
  ctx.font = `${weight} ${size}px Outfit`;
  const words = (text || "").split(" ");
  const lines = [];
  let cur = "";
  words.forEach((w) => {
    const t = cur ? `${cur} ${w}` : w;
    if (ctx.measureText(t).width > max && cur) { lines.push(cur); cur = w; } else cur = t;
  });
  if (cur) lines.push(cur);
  lines.slice(0, maxLines).forEach((l, i) => ctx.fillText(l, cx, y + i * lh));
  return Math.min(lines.length, maxLines);
}

function brandRow(ctx, x, y, color, tile, fg) {
  mark(ctx, x, y - 22, 44, tile, fg);
  ctx.textAlign = "left";
  ctx.fillStyle = color;
  ctx.font = "700 30px Outfit";
  ctx.fillText("hostkey", x + 56, y + 10);
  const w = ctx.measureText("hostkey").width;
  ctx.font = "300 30px Outfit";
  ctx.fillText(".online", x + 56 + w, y + 10);
}

export function drawPortrait(c, { name, hostName, qr, logo, tagline = "Tap or scan to check in" }) {
  const ctx = c.getContext("2d");
  const [W, H] = PORTRAIT;
  ctx.clearRect(0, 0, W, H);
  ctx.beginPath();
  ctx.roundRect(0, 0, W, H, 44);
  ctx.fillStyle = NAVY;
  ctx.fill();
  ctx.beginPath();
  ctx.roundRect(99, 80, 440, 440, 30);
  ctx.fillStyle = "#FFFFFF";
  ctx.fill();
  if (qr) ctx.drawImage(qr, 124, 105, 390, 390);
  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(244,246,248,.7)";
  ctx.font = "500 24px DM Sans";
  ctx.letterSpacing = "5px";
  ctx.fillText(tagline.toUpperCase(), W / 2, 580);
  ctx.letterSpacing = "0px";
  ctx.fillStyle = LIGHT;
  const n = wrapCenter(ctx, name || "Your Airbnb", W / 2, 662, 520, 56, 600, 64);
  const yLine = 662 + n * 64 + 6;
  ctx.fillStyle = "rgba(244,246,248,.15)";
  ctx.fillRect(70, yLine, W - 140, 2);
  const yHost = yLine + 90;
  ctx.save();
  ctx.beginPath();
  ctx.arc(W / 2, yHost, 52, 0, Math.PI * 2);
  ctx.fillStyle = "#1E2A44";
  ctx.fill();
  if (logo) {
    ctx.clip();
    const s = Math.max(104 / logo.width, 104 / logo.height);
    ctx.drawImage(logo, W / 2 - (logo.width * s) / 2, yHost - (logo.height * s) / 2, logo.width * s, logo.height * s);
  } else {
    ctx.fillStyle = LIGHT;
    ctx.textAlign = "center";
    ctx.font = "600 44px Outfit";
    ctx.fillText((hostName || "H")[0].toUpperCase(), W / 2, yHost + 15);
  }
  ctx.restore();
  ctx.textAlign = "center";
  ctx.fillStyle = "rgba(244,246,248,.8)";
  ctx.font = "400 24px DM Sans";
  if (hostName) ctx.fillText(`Hosted by ${hostName}`, W / 2, yHost + 90);
  brandRow(ctx, W / 2 - 150, H - 62, LIGHT, LIGHT, NAVY);
}

export function drawHkCard(c, { name, qr }) {
  const ctx = c.getContext("2d");
  const [W, H] = PORTRAIT;
  ctx.clearRect(0, 0, W, H);
  ctx.beginPath();
  ctx.roundRect(0, 0, W, H, 44);
  ctx.fillStyle = "#FFFFFF";
  ctx.fill();
  ctx.fillStyle = "#2F6B4F";
  ctx.beginPath();
  ctx.roundRect(0, 0, W, 210, [44, 44, 0, 0]);
  ctx.fill();
  ctx.textAlign = "center";
  ctx.fillStyle = "#FFFFFF";
  ctx.font = "700 46px Outfit";
  ctx.letterSpacing = "6px";
  ctx.fillText("HOUSEKEEPING", W / 2, 110);
  ctx.letterSpacing = "0px";
  ctx.font = "400 26px DM Sans";
  ctx.fillText("Staff checklist & comments", W / 2, 158);
  ctx.beginPath();
  ctx.roundRect(119, 260, 400, 400, 26);
  ctx.strokeStyle = "#D7E2DC";
  ctx.lineWidth = 4;
  ctx.stroke();
  if (qr) ctx.drawImage(qr, 139, 280, 360, 360);
  ctx.fillStyle = NAVY;
  wrapCenter(ctx, name || "Your Airbnb", W / 2, 740, 520, 46, 600, 54);
  ctx.fillStyle = "#5B6470";
  ctx.font = "400 24px DM Sans";
  ctx.fillText("Scan after every clean to tick the list", W / 2, 860);
  brandRow(ctx, W / 2 - 150, H - 60, NAVY, NAVY, LIGHT);
}
